module.exports = __webpack_public_path__ + "static/img/25.6f582617.gif";